export default "__VITE_ASSET__C2IBv1ig__"